/* FizzyIQ — PDP bundle builder (fizzy-pdp-bundle / bb-).
   Sam 2026-08-29.

   The page carries a FINISHED box: a real plan, a filled set of flavours, a
   live price and a live add-to-cart. The modal holds only the editing. That
   ordering came out of the second pass — the first build put add-to-cart
   inside the dialog, which turned the modal into a gate in front of the one
   action that matters. Both direct competitors ship a complete, purchasable
   configuration and ask at most one question; this matches that.

   Two rules keep it honest:

   1. NO SECOND COPY OF STATE. Age, plan, flavours, pricing and the cart
      payload all still belong to assets/fizzy-pdp-hero.js. This file fills the
      box by CLICKING the real controls and reads the summary back out of the
      DOM those controls own. If it held its own copy the two would drift.

   2. TOP UP ONLY WHEN THE REQUIREMENT MOVED, never when the shopper did.
      Changing plan or age changes how many pouches a box needs, so the box is
      refilled to stay buyable. Editing flavours is the shopper deciding, and
      re-adding what they just removed would make the steppers feel broken.

   Styles: assets/fizzy-pdp-bundle.css */
(function () {
  'use strict';

  if (window.__fizzyBundleBuilder) return;
  window.__fizzyBundleBuilder = true;

  var dlg = document.getElementById('bundleBuilder');
  if (!dlg) return; /* inline mode */

  var summary = document.getElementById('bbSummary');
  var counter = document.getElementById('bundleCounter');
  var picker  = document.getElementById('flavorPicker');

  /* Fill order. One of each before a second of any, so a box big enough to
     hold them arrives as a sampler rather than as four of the bestseller;
     a one-pouch box gets Berry Cherry, which the markup already flags as the
     bestseller. */
  var ORDER = ['bc', 'sl', 'wm', 'ob'];

  var NAMES = { bc: 'Berry Cherry', sl: 'Strawberry Lemonade', wm: 'Watermelon', ob: 'Orange Creamsicle' };

  /* The counter is the module's own rendering of "how many are picked, of how
     many are needed", so reading it is reading that module's state rather than
     guessing at it. */
  function counts() {
    if (!counter) return null;
    var b = counter.querySelectorAll('b');
    if (b.length < 2) return null;
    var have = parseInt(b[0].textContent, 10);
    var need = parseInt(b[1].textContent, 10);
    return (isNaN(have) || isNaN(need)) ? null : { have: have, need: need };
  }

  /* Always add to whichever flavour currently has the fewest, ties broken by
     ORDER. Walking ORDER from the top instead put a second Berry Cherry in
     before Watermelon had its first, so a three-pouch box came out 2/1/0/0
     rather than one of each. Re-sorting after every single add is what makes
     it a true round robin. */
  function lowestFirst() {
    return ORDER.map(function (k, i) { return { key: k, qty: qtyOf(k), ord: i }; })
                .sort(function (a, b) { return (a.qty - b.qty) || (a.ord - b.ord); });
  }

  function topUp() {
    if (!picker) return;
    var hero = document.getElementById('pdpHero');
    if (hero && hero.dataset.purchasePlan === 'stick15') return;
    var guard = 0;
    while (guard++ < 40) {
      var c = counts();
      if (!c || c.have >= c.need) return;

      var moved = false;
      var order = lowestFirst();
      for (var i = 0; i < order.length; i++) {
        var tile = picker.querySelector('.opt[data-f="' + order[i].key + '"]');
        if (!tile || tile.classList.contains('soldout')) continue;

        var before = c.have;
        var add = tile.querySelector('.inc');
        if (!add || add.disabled) continue;
        add.click();
        var after = counts();
        if (after && after.have > before) { moved = true; break; }
      }
      /* Nothing could be added — every flavour is sold out or capped. Leave the
         box short rather than spinning; the button stays disabled and says so. */
      if (!moved) return;
    }
  }

  function qtyOf(key) {
    var badge = picker && picker.querySelector('.opt-badge[data-f="' + key + '"]');
    var n = badge ? parseInt(badge.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  function renderSummary() {
    if (!summary) return;

    var planEl = document.querySelector('.plans .tier.selected');
    var stick = planEl && planEl.dataset.plan === 'stick15';
    var summaryLabel = summary.querySelector('.bb-summary__label');
    if (summaryLabel) summaryLabel.textContent = stick ? 'Your stickpack bundle' : 'Your box';
    var ageEl  = document.querySelector('.age-picker .opt.selected .an');
    var line   = summary.querySelector('[data-bb-plan]');
    var list   = summary.querySelector('[data-bb-flavors]');

    if (line) {
      var bits = [];
      var name = planEl && planEl.querySelector('.tname-label');
      var srv  = planEl && planEl.querySelector(stick ? '[data-stick-size]' : '.tnote-srv');
      if (name) bits.push(name.textContent.trim());
      if (srv) bits.push(srv.textContent.trim() + (stick ? '' : ' servings'));
      if (ageEl && !stick) bits.push(ageEl.textContent.trim());
      line.textContent = bits.join(' · ');
    }

    if (list) {
      list.innerHTML = '';
      for (var i = 0; i < ORDER.length; i++) {
        var q = qtyOf(ORDER[i]);
        if (q < 1) continue;
        var li = document.createElement('li');
        li.className = 'bb-summary__flavor';
        li.setAttribute('data-f', ORDER[i]);
        li.textContent = NAMES[ORDER[i]] + (q > 1 ? ' × ' + q : '') + (stick ? ' sticks' : '');
        list.appendChild(li);
      }
      /* Reachable when every flavour is sold out, or when a shopper clears the
         box and closes the dialog. The disabled button already explains it; the
         summary should not sit there empty and silent beside it. */
      if (!list.children.length) {
        var empty = document.createElement('li');
        empty.className = 'bb-summary__flavor bb-summary__flavor--empty';
        empty.textContent = 'No flavors chosen yet';
        list.appendChild(empty);
      }
    }
  }

  /* ── the dialog ─────────────────────────────────────────────────────── */

  var lockedScroll = false;

  function lockScroll() {
    if (lockedScroll) return;
    lockedScroll = true;
    var gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('bb-open');
  }

  function unlockScroll() {
    if (!lockedScroll) return;
    lockedScroll = false;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.classList.remove('bb-open');
  }

  function open() {
    if (dlg.open) return;
    if (typeof dlg.showModal === 'function') window.fizzyPopupMotion.open(dlg);
    else dlg.setAttribute('open', '');
    lockScroll();
    /* The controls were display:none until now, so anything inside that
       measured itself on load has stale numbers. */
    window.dispatchEvent(new Event('resize'));
  }

  function close() {
    if (typeof dlg.close === 'function' && dlg.open) window.fizzyPopupMotion.close(dlg);
    else { dlg.removeAttribute('open'); unlockScroll(); }
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!(t instanceof Element)) return;

    if (t.closest('[data-bb-open]')) { open(); return; }
    if (t.closest('[data-bb-close]')) { close(); return; }
    if (t === dlg) { close(); return; }

    if (!dlg.contains(t)) return;

    /* Only the refill is timed off the click, and only when the requirement
       moved. Redrawing the summary is the observer's job below — reading the
       controls on a timer raced the module's own update and could show a
       quantity one edit behind. */
    if (t.closest('.age-picker, .plans')) setTimeout(topUp, 0);
  });

  /* The controls are rewritten by fizzy-pdp-hero.js through several paths:
     clicks, arrow keys, plan changes trimming the box, stock gating. Watching
     the result covers all of them and cannot fall out of step with any.
     #bbSummary sits outside the dialog, so redrawing it cannot retrigger this. */
  var frame = 0;
  function scheduleRender() {
    if (frame) return;
    frame = requestAnimationFrame(function () { frame = 0; renderSummary(); });
  }

  new MutationObserver(scheduleRender).observe(dlg, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'data-f', 'aria-checked', 'disabled']
  });

  dlg.addEventListener('close', function () {
    unlockScroll();
    renderSummary();
  });

  /* Arrow keys move the age and plan radiogroups without a click, and that
     moves the requirement. The observer redraws; this is only the refill. */
  dlg.addEventListener('keyup', function (event) {
    var k = event.key;
    if (k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'ArrowUp' && k !== 'ArrowDown' && k !== 'Home' && k !== 'End') return;
    if (event.target && event.target.closest && event.target.closest('.age-picker, .plans')) setTimeout(topUp, 0);
  });

  /* ── arrive with a finished box ─────────────────────────────────────── */

  function init() {
    topUp();
    renderSummary();
  }

  /* fizzy-pdp-hero.js is deferred too, and it has to have rendered the counter
     and the tiles before any of this can read them. Both scripts run in order,
     but its own init may finish asynchronously, so this retries briefly rather
     than assuming. */
  var tries = 0;
  (function ready() {
    if (counts() || tries++ > 40) { init(); return; }
    setTimeout(ready, 50);
  })();
})();
